import React from 'react';
import { gql } from '@apollo/client';
import { useMutation } from '@pv/common/hooks';
import { useNavigate } from 'react-router-dom';
import {
  Button,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
} from '@mui/material';

const archiveVenueMutation = gql`
  mutation ArchiveVenue($input: AdminUpdateVenueInput!) {
    adminUpdateVenue(input: $input) {
      adminVenue {
        id
        name
        discardedAt
      }
    }
  }
`;

interface Venue {
  id: string;
  name: string;
  discardedAt: string;
}

export const ArchiveVenueModal = ({
  open,
  onClose,
  venue,
}: {
  open: boolean;
  onClose: () => void;
  venue: Venue;
}) => {
  const navigate = useNavigate();
  const [archiveOrganization, { loading }] = useMutation(archiveVenueMutation, {
    onCompleted: () => {
      onClose();
      navigate(`/admin/venues/${venue.id}/info`);
    },
  });
  const isArchived = !!venue.discardedAt;
  const onConfirm = () => {
    archiveOrganization({
      variables: {
        input: { id: venue.id, archived: !isArchived },
      },
    });
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>
        {isArchived ? 'Restore Archived Venue' : 'Archive Venue'}
      </DialogTitle>
      <DialogContent>
        <Typography>
          Are you sure you want to {isArchived ? ' unarchive ' : ' archive '}
          {venue.name}?
        </Typography>
        {!isArchived && (
          <Typography>
            This will hide the venue from the admin interface and the
            marketplace.
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" color="primary" onClick={onClose}>
          Cancel
        </Button>
        <Button variant="contained" color="secondary" onClick={onConfirm}>
          {loading ? (
            <>
              Confirming <CircularProgress size={20} color="inherit" />
            </>
          ) : (
            'Confirm'
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
